import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import latinize from 'latinize';
import styles from "./styles.module.css";
import { Box, Button, DialogActions, DialogContent, Grid } from "@mui/material";
import GenericTextField from "../../components/GenericTextField";

const ServicoFormSchema = z.object({
  idServico: z.number().readonly(),
  descricao: z.string().min(1, {
    message: "Nome do serviço é obrigatório"
  }),
})
.partial({
  idServico: true
})
.required({
  descricao: true
});


type ServicoFormData = z.infer<typeof ServicoFormSchema>;

type ServicoFormProps = {
  servicoValues: ServicoFormData;
  onSubmit(data: ServicoFormData): void;
  onClose(event: any): void;
}

export default function ServicoForm({ servicoValues, onSubmit, onClose }: ServicoFormProps) {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm<ServicoFormData>({
    mode: "onChange",
    resolver: zodResolver(ServicoFormSchema),
    defaultValues: {
      idServico: servicoValues.idServico || undefined,
      descricao: servicoValues.descricao || '',
    }
  });

  const handleCloseForm = (event: any) => {
    onClose(event);
  }

  const handleDescricaoChange = (event: any) => {
    const descricaoValue = event.target.value;
    const adjustedDescricaoValue = latinize(descricaoValue)
      .toUpperCase();

    setValue("descricao", adjustedDescricaoValue, { shouldValidate: true });
  }

  const submit = (data: ServicoFormData) => {
    const body : any = {
      servico: {
        descricao: data.descricao,
      },
    };

    onSubmit(body);
  }

  return (
    <form onSubmit= { handleSubmit(submit) } className={styles.formDiv}>
      <DialogContent className={styles.formContainer}>
        <Box className={styles.formContent}>
          <Grid container spacing={2}>
            <Grid item xs={2}>
              <Controller
                name="idServico"
                control={control}
                defaultValue={servicoValues.idServico}
                render={({ field: { ref, ...field } }) => (
                  <GenericTextField
                    disabled
                    label="ID"
                    error={Boolean(errors.idServico)}
                    helperText={errors.idServico?.message}
                    placeholder={'Novo usuário'}
                    inputRef={ref}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={10}>
              <Controller
                name="descricao"
                control={control}
                defaultValue={servicoValues.descricao}
                render={({ field: { ref, onChange, ...field } }) => (
                  <GenericTextField
                    required
                    label="Nome do Serviço"
                    placeholder="Digite o nome do serviço"
                    error={Boolean(errors.descricao)}
                    onChange={(data: any) => {
                      onChange(data);
                      handleDescricaoChange(data);
                    }}
                    helperText={errors.descricao?.message}
                    inputRef={ref}
                    {...field}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Box>
          <Box>
            <DialogActions className={styles.botoesPopupGeral}>
              <Button
                className={styles.botaoPopupCancelar}
                onClick={handleCloseForm}
                size="small"
              >
                Cancelar
              </Button>
              <Button
                className={styles.botaoPopupSalvar}
                type="submit"
                color="primary"
                size="small"
              >
                Salvar
              </Button>
            </DialogActions>
          </Box>
      </DialogContent>
    </form>
  );

}